import React from "react";
import ScreenSettingTable from "./ScreenSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showScreenSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function ScreenSetting() {
  const dispatch = useDispatch();
  const { screen } = useSelector(responseSetting);

  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showScreenSetting());
  }, [dispatch]);
  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>ScreenSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>ScreenSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <ScreenSettingTable dataSource={screen} />
        </div>
      </div>
    </>
  );
}
